import { MapColoringPieChart } from "../../pie-chart/MapColoringPieChart";
import { Box, HStack, Stack } from "@chakra-ui/react";
import { MapColoringSelector } from "../../MapColoring/MapColoringSelector";
import { MapColoringLegend } from "../../MapColoring/MapColoringLegend";
import { MapColoring } from "../../../../../map/models/MapColoring";
import { SurveyPermissions } from "../../../../../survey/models/Survey";

export const PieChartMapColoring: React.FC<{
  value: MapColoring;
  onChange: (value: MapColoring) => void;
  surveyPermissions?: SurveyPermissions;
  speedUnit: string;
}> = ({ value, onChange, surveyPermissions, speedUnit }) => {
  return (
    <Stack w="100%">
      {surveyPermissions?.canManageResults && (
        <HStack justifyContent="center" pt={4} px={4}>
          <MapColoringSelector value={value} onChange={onChange} />
        </HStack>
      )}
      <HStack justifyContent="center" gap={0}>
        <MapColoringPieChart coloring={value} />
        <Box py={2} pr={4} maxW="200px" minWidth="160px" flexShrink={0}>
          <MapColoringLegend coloring={value} speedUnit={speedUnit} />
        </Box>
      </HStack>
    </Stack>
  );
};
